import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './AboutPage.css';
import aboutStory from '../assets/piclogoabout.png';
import directorImg from '../assets/directorkisan.jpeg';
import Header from '../components/Header';
import Footer from '../components/Footer';

// Timeline Assets
import kisanImg from '../assets/kisan.png';
import thresherImg from '../assets/thresher.png';
import harvesterImg from '../assets/harvester.png';
import rotavatorImg from '../assets/rotavator_1.png';
import bcsImg from '../assets/bcs.png';
import shaktimanImg from '../assets/shaktiman.png';
import logoImg from '../assets/kissanmanlogo.png';
import ploughImg from '../assets/plough_1.png';
import cultivatorImg from '../assets/cultivator_1.png';
import sonalikaImg from '../assets/tra1.jpeg';
import trailerImg from '../assets/water_tank_clean.png';
import mahindraImg from '../assets/tra2.jpeg';
import trophyImg from '../assets/agribul.png';
import groupImg from '../assets/piclogoabout.png';


const AboutPage = () => {
  const { t } = useTranslation();
  const [isTimelineExpanded, setIsTimelineExpanded] = useState(false);
  const stats = useMemo(() => [
    {
      value: t('about.stats.manufacturing'),
      sub: t('about.stats.facility'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M3.99902 39.987C3.99902 41.0475 4.42031 42.0646 5.17022 42.8145C5.92012 43.5644 6.9372 43.9857 7.99772 43.9857H39.9873C41.0478 43.9857 42.0649 43.5644 42.8148 42.8145C43.5647 42.0646 43.986 41.0475 43.986 39.987V15.9948L29.9906 25.9916V15.9948L15.9951 25.9916V7.99742C15.9951 6.9369 15.5738 5.91981 14.8239 5.16991C14.074 4.42001 13.0569 3.99872 11.9964 3.99872H7.99772C6.9372 3.99872 5.92012 4.42001 5.17022 5.16991C4.42031 5.91981 3.99902 6.9369 3.99902 7.99742V39.987Z" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M33.9893 35.9883H35.9886" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23.9922 35.9883H25.9915" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M13.9951 35.9883H15.9945" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
    },
    {
      value: t('about.stats.customers'),
      sub: t('about.stats.happy_customers'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M31.9899 41.9863V37.9876C31.9899 35.8666 31.1473 33.8324 29.6475 32.3326C28.1477 30.8328 26.1136 29.9902 23.9925 29.9902H11.9964C9.87538 29.9902 7.84121 30.8328 6.34141 32.3326C4.8416 33.8324 3.99902 35.8666 3.99902 37.9876V41.9863" stroke="#E46C25" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17.9945 21.9928C22.4113 21.9928 25.9919 18.4123 25.9919 13.9954C25.9919 9.5786 22.4113 5.99805 17.9945 5.99805C13.5776 5.99805 9.99707 9.5786 9.99707 13.9954C9.99707 18.4123 13.5776 21.9928 17.9945 21.9928Z" stroke="#E46C25" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M43.9854 41.9864V37.9877C43.984 36.2157 43.3943 34.4943 42.3086 33.0939C41.223 31.6934 39.703 30.6932 37.9873 30.2502" stroke="#E46C25" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M31.9893 6.258C33.7095 6.69845 35.2343 7.69893 36.3231 9.10169C37.412 10.5045 38.003 12.2297 38.003 14.0055C38.003 15.7812 37.412 17.5065 36.3231 18.9093C35.2343 20.312 33.7095 21.3125 31.9893 21.753" stroke="#E46C25" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
    },
    {
      value: t('about.stats.products'),
      sub: t('about.stats.products_label'),
      icon: (
        <svg width="45" height="45" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7"></circle>
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
        </svg>
      ),
    },
    {
      value: t('about.stats.dealers'),
      sub: t('about.stats.dealer_network'),
      icon: (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <path d="M23.9925 43.9857C35.0346 43.9857 43.986 35.0343 43.986 23.9922C43.986 12.9501 35.0346 3.99872 23.9925 3.99872C12.9504 3.99872 3.99902 12.9501 3.99902 23.9922C3.99902 35.0343 12.9504 43.9857 23.9925 43.9857Z" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23.9922 35.9883C30.6175 35.9883 35.9883 30.6175 35.9883 23.9922C35.9883 17.3669 30.6175 11.9961 23.9922 11.9961C17.3669 11.9961 11.9961 17.3669 11.9961 23.9922C11.9961 30.6175 17.3669 35.9883 23.9922 35.9883Z" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M23.9919 27.9909C26.2003 27.9909 27.9906 26.2006 27.9906 23.9922C27.9906 21.7837 26.2003 19.9935 23.9919 19.9935C21.7834 19.9935 19.9932 21.7837 19.9932 23.9922C19.9932 26.2006 21.7834 27.9909 23.9919 27.9909Z" stroke="#4BA83D" strokeWidth="3.9987" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
    },
  ], [t]);

  const timelineItems = useMemo(() => [
    {
      year: '1968',
      title: 'FOUNDATION LAID',
      bullets: [
        'Incorporation of Kisan Engineering Company',
        'Brand launched: KISAN'
      ],
      image: kisanImg
    },
    {
      year: '1972',
      title: 'MANUFACTURING BEGINS',
      bullets: [
        'Foundry & casting operations established',
        '52+ agri components produced under one roof'
      ],
      image: ploughImg
    },
    {
      year: '1972-92',
      title: 'AGRI IMPLEMENTS EXPANSION',
      bullets: [
        'Introduced: Threshers, Cultivators, Trolleys',
        'Supplied steel structures to Bihar & Jharkhand Electricity Boards',
        'Brand KISAN earned market trust'
      ],
      image: thresherImg
    },
    {
      year: '1992',
      title: 'SCALING PRODUCTION',
      bullets: [
        'Started bulk manufacturing',
        '1000+ agri units produced annually'
      ],
      image: cultivatorImg
    },
    {
      year: '1998-2001',
      title: 'SCALING PRODUCTION',
      bullets: [
        'Sonalika Tractors dealership for Bihar & Nepal'
      ],
      image: sonalikaImg
    },
    {
      year: '2003',
      title: 'PARTNERSHIP WITH SHAKTIMAN',
      bullets: [
        'Rotavator dealership added',
        'Core manufacturing continued'
      ],
      image: rotavatorImg
    },
    {
      year: '2004-2009',
      title: 'INDUSTRIAL FABRICATION GROWTH',
      bullets: [
        'Water tanks & MNC structural works',
        'Vendor to 27+ MNCs'
      ],
      image: trailerImg
    },
    {
      year: '2008',
      title: 'REBRANDING',
      bullets: [
        'Renamed to Kisan Engineering Works'
      ],
      image: logoImg
    },
    {
      year: '2009',
      title: 'STATE DISTRIBUTION BEGINS',
      bullets: [
        'Appointed Shaktiman State Distributor (Bihar)'
      ],
      image: shaktimanImg
    },
    {
      year: '2010',
      title: 'GLOBAL TECHNOLOGY ACCESS',
      bullets: [
        'Signed BCS India Pvt. Ltd dealership ( Italian Reaper Binder )'
      ],
      image: bcsImg
    },
    {
      year: '2012',
      title: 'STATEWIDE PRESENCE',
      bullets: [
        'Acquired BCS full product distributorship for Bihar'
      ],
      image: bcsImg
    },
    {
      year: '2014-2019',
      title: 'REGIONAL LEADERSHIP',
      bullets: [
        'Mahindra Tractor dealership added',
        'Top manufacturer in Bihar for Threshers, Harrows, Cultivators',
        'Minimal exports to Nepal began'
      ],
      image: mahindraImg
    },
    {
      year: '2016-2018',
      title: 'NEW ALLIANCES',
      bullets: [
        'Claas Combine, Piaggio, Bull India, Vikas Harvester dealerships'
      ],
      image: harvesterImg
    },
    {
      year: '2020-2021',
      title: 'RESILIENCE AMIDST CRISIS',
      bullets: [
        'Achieved record sales during COVID'
      ],
      image: trophyImg
    },
    {
      year: '2023',
      title: 'GROUP STRUCTURING',
      bullets: [
        'New entity: Kisan Tradecom Pvt. Ltd. for distribution',
        'Strong growth trajectory continued'
      ],
      image: groupImg
    },
    {
      year: '2024-2025',
      title: 'PRESENT DAY',
      bullets: [
        'State distributors for BCS & Shaktiman',
        '18+ active brand partnerships',
        'Recognized as Bihar\'s leading agri-equipment group'
      ],
      images: [bcsImg, shaktimanImg]
    }
  ], []);

  const displayedTimeline = isTimelineExpanded ? timelineItems : timelineItems.slice(0, 4);

  return (
    <div className="about-page">
      <Header />

      {/* Page Title */}
      <section className="about-hero">
        <div className="about-hero-top-bar"></div>
        <div className="container">
          <h1 className="about-title">{t('about.title')}</h1>
        </div>
      </section>

      {/* Our Story */}
      <section className="our-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-text">
              <h2 className="story-heading">{t('about.our_story')}</h2>
              <p>
                {t('about.story_p1')}
              </p>
              <p>
                {t('about.story_p2')}
              </p>
            </div>
            <div className="story-image-wrap">
              <img src={aboutStory} alt="Kisaan Maan Story" className="story-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="about-stats">
        <div className="container">
          <div className="about-stats-grid">
            {stats.map((item, idx) => (
              <div key={idx} className="about-stat-item">
                <div className="about-stat-icon">{item.icon}</div>
                <h3 className="about-stat-value">{item.value}</h3>
                <p className="about-stat-sub">{item.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Company Timeline */}
      <section className="company-timeline">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '60px' }}>
            <span className="timeline-badge">{t('about.timeline.badge')}</span>
            <h2 className="section-title" style={{ color: '#1a1a1a' }}>{t('about.timeline.title')}</h2>
            <p className="section-subtitle">{t('about.timeline.subtitle')}</p>
          </div>

          <div className="timeline-wrapper">
            <div className="timeline-line"></div>

            {displayedTimeline.map((item, idx) => {
              const side = idx % 2 === 0 ? 'left' : 'right';
              return (
                <div key={idx} className={`timeline-row ${side}`}>
                  <div className="timeline-card">
                    <div className="timeline-year">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '6px'}}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                      {item.year}
                    </div>
                    <h3 className="timeline-title">{item.title}</h3>
                    <ul className="timeline-bullets" style={{ margin: '8px 0 12px 0', paddingLeft: '18px', listStyleType: 'disc', color: '#666', fontSize: '13.5px', lineHeight: '1.6', textAlign: 'left' }}>
                      {item.bullets.map((b, i) => (
                        <li key={i} style={{ marginBottom: '6px' }}>{b}</li>
                      ))}
                    </ul>
                    {item.images ? (
                      <div className="timeline-img-wrapper" style={{ width: '100%', overflow: 'hidden', borderRadius: '10px', marginTop: '10px', display: 'flex' }}>
                        {item.images.map((img, i) => (
                          <img key={i} src={img} alt={item.title} className="timeline-card-img" style={{ width: '50%', height: '150px', objectFit: 'contain', display: 'block', transition: 'transform 0.3s ease', padding: '10px' }} />
                        ))}
                      </div>
                    ) : item.image ? (
                      <div className="timeline-img-wrapper" style={{ width: '100%', overflow: 'hidden', borderRadius: '10px', marginTop: '10px' }}>
                        <img src={item.image} alt={item.title} className="timeline-card-img" style={{ width: '100%', height: '150px', objectFit: 'contain', display: 'block', transition: 'transform 0.3s ease' }} />
                      </div>
                    ) : null}
                  </div>
                  <div className="timeline-dot"></div>
                </div>
              );
            })}
          </div>

          <div className="timeline-toggle-wrapper">
            <button 
              className="timeline-toggle-btn" 
              onClick={() => setIsTimelineExpanded(!isTimelineExpanded)}
            >
              <span>{isTimelineExpanded ? 'SHOW LESS' : 'SHOW FULL TIMELINE'}</span>
              <svg 
                width="18" 
                height="18" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2.5" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                style={{ 
                  transform: isTimelineExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </section>

      {/* Infrastructure Section */}
      <section className="infrastructure-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '50px' }}>
            <span className="infra-badge">{t('about.infra.badge', 'INFRASTRUCTURE')}</span>
            <h2 className="section-title" style={{ color: '#1a1a1a' }}>{t('about.infra.title', 'Our State-of-the-Art Infrastructure')}</h2>
            <p className="section-subtitle">{t('about.infra.subtitle', 'Equipped with modern machinery and high-precision engineering systems')}</p>
          </div>

          <div className="infra-grid">
            <div className="infra-card">
              <div className="infra-icon-wrapper green">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect>
                  <rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect>
                  <line x1="6" y1="6" x2="6.01" y2="6"></line>
                  <line x1="6" y1="18" x2="6.01" y2="18"></line>
                </svg>
              </div>
              <h3 className="infra-card-title">{t('about.infra.card1_title', 'Manufacturing & Assembly Facility')}</h3>
              <p className="infra-card-desc">{t('about.infra.card1_desc', 'Our facility at Bela Industrial Estate, Muzaffarpur spans across a massive area equipped with advanced CNC tooling, laser cutters, automatic welding arms, and precision fabrication equipment for robust agricultural implements.')}</p>
            </div>

            <div className="infra-card">
              <div className="infra-icon-wrapper orange">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
              </div>
              <h3 className="infra-card-title">{t('about.infra.card2_title', 'Foundry & Heavy Casting')}</h3>
              <p className="infra-card-desc">{t('about.infra.card2_desc', 'In-house high-grade casting unit and induction furnace. This allows us to manufacture heavy-duty gears, robust gearboxes, and highly durable tillage parts that match the demanding soil conditions of Bihar.')}</p>
            </div>

            <div className="infra-card">
              <div className="infra-icon-wrapper yellow">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="12"></line>
                  <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
              </div>
              <h3 className="infra-card-title">{t('about.infra.card3_title', 'Quality Control & R&D Lab')}</h3>
              <p className="infra-card-desc">{t('about.infra.card3_desc', 'Every machine goes through extensive testing protocols in our testing bays. From tensile strength analysis to field-simulation operations, we guarantee structural integrity and peak field efficiency.')}</p>
            </div>

            <div className="infra-card">
              <div className="infra-icon-wrapper green">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
              <h3 className="infra-card-title">{t('about.infra.card4_title', 'Smart Storage & Logistics Hub')}</h3>
              <p className="infra-card-desc">{t('about.infra.card4_desc', 'Large dedicated warehousing with digital stock-tracking. Over 10,000+ spare parts catalogued under automated logistics management, ensuring 100% on-time spare delivery and quick distribution nationwide.')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Board of Directors */}
      <section className="board-section">
        <div className="container">
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '50px' }}>
            <span className="board-badge">{t('about.leadership.badge')}</span>
            <h2 className="section-title" style={{ color: '#1a1a1a' }}>{t('about.leadership.title')}</h2>
            <p className="section-subtitle">{t('about.leadership.subtitle')}</p>
          </div>

          <div className="board-grid">
            {[
              {
                initials: 'MA',
                name: t('about.leadership.rk_name'),
                role: t('about.leadership.rk_role'),
                edu: t('about.leadership.rk_edu'),
                exp: t('about.leadership.rk_exp'),
                vision: t('about.leadership.rk_vision'),
                img: directorImg,
              },
            ].map((dir, idx) => (
              <div key={idx} className="director-card">
                <div className="director-top">
                  {dir.img ? (
                    <img src={dir.img} alt={dir.name} className="director-avatar-img" />
                  ) : (
                    <div className="director-avatar">{dir.initials}</div>
                  )}
                  <div>
                    <h3 className="director-name">{dir.name}</h3>
                    <p className="director-role">{dir.role}</p>
                  </div>
                </div>
                <div className="director-divider"></div>
                <div className="director-meta">
                  <div className="meta-item">
                    <span className="meta-label">{t('about.leadership.edu_label')}</span>
                    <span className="meta-val">{dir.edu}</span>
                  </div>
                  <div className="meta-item">
                    <span className="meta-label">{t('about.leadership.exp_label')}</span>
                    <span className="meta-val">{dir.exp}</span>
                  </div>
                </div>
                <div className="director-vision">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" style={{marginRight: '8px', flexShrink: 0}}>
                    <g clipPath={`url(#clip_vision_${idx})`}>
                      <path d="M9.99535 18.3244C14.5955 18.3244 18.3247 14.5953 18.3247 9.9951C18.3247 5.39494 14.5955 1.66577 9.99535 1.66577C5.39518 1.66577 1.66602 5.39494 1.66602 9.9951C1.66602 14.5953 5.39518 18.3244 9.99535 18.3244Z" stroke="#4BA83D" strokeWidth="1.66587" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M9.99565 14.9928C12.7557 14.9928 14.9932 12.7553 14.9932 9.99516C14.9932 7.23506 12.7557 4.99756 9.99565 4.99756C7.23555 4.99756 4.99805 7.23506 4.99805 9.99516C4.99805 12.7553 7.23555 14.9928 9.99565 14.9928Z" stroke="#4BA83D" strokeWidth="1.66587" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M9.99497 11.6611C10.915 11.6611 11.6608 10.9152 11.6608 9.99521C11.6608 9.07518 10.915 8.32935 9.99497 8.32935C9.07494 8.32935 8.3291 9.07518 8.3291 9.99521C8.3291 10.9152 9.07494 11.6611 9.99497 11.6611Z" stroke="#4BA83D" strokeWidth="1.66587" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                      <clipPath id={`clip_vision_${idx}`}>
                        <rect width="19.9904" height="19.9904" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                  <span className="vision-label">{t('about.leadership.vision_label')}</span>
                </div>
                <p className="director-vision-text">{dir.vision}</p>
              </div>
            ))}
          </div>

          {/* Company Information */}
          <div className="company-info-box">
            <h3 className="company-info-title">{t('about.info.title')}</h3>
            <div className="company-info-grid">
              <div className="info-card">
                <div className="info-icon-title">
                  <svg width="23.992" height="23.992" viewBox="0 0 24 24" fill="none" stroke="#4BA83D" style={{flexShrink: 0}}>
                    <path d="M1.99902 19.9934C1.99902 20.5237 2.20967 21.0322 2.58462 21.4072C2.95957 21.7821 3.46811 21.9928 3.99837 21.9928H19.9932C20.5234 21.9928 21.032 21.7821 21.4069 21.4072C21.7819 21.0322 21.9925 20.5237 21.9925 19.9934V7.99732L14.9948 12.9957V7.99732L7.99707 12.9957V3.99862C7.99707 3.46836 7.78643 2.95981 7.41148 2.58486C7.03653 2.20991 6.52798 1.99927 5.99772 1.99927H3.99837C3.46811 1.99927 2.95957 2.20991 2.58462 2.58486C2.20967 2.95981 1.99902 3.46836 1.99902 3.99862V19.9934Z" stroke="#4BA83D" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.9941 17.9941H17.9941" stroke="#4BA83D" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M11.9961 17.9941H12.9961" stroke="#4BA83D" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6.99805 17.9941H7.99805" stroke="#4BA83D" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <strong>{t('about.info.reg_office')}</strong>
                </div>
                <div className="info-address-details" style={{ fontSize: '14px', lineHeight: '1.6', color: '#666' }}>
                  <p style={{ margin: '4px 0' }}><strong>H.O.:</strong> {t('about.info.ho_val', 'Bela Industrial Estate, Phase, MIC Bela, Muzaffarpur-842005 (Bihar)')}</p>
                  <p style={{ margin: '4px 0' }}><strong>B.O.:</strong> {t('about.info.bo_val', 'NH-31, Maranga, Beside TATA Motors, Purnia-854301 (Bihar)')}</p>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon-title">
                  <svg width="23.992" height="23.992" viewBox="0 0 24 24" fill="none" style={{flexShrink: 0}}>
                    <path d="M19.9938 12.9957C19.9938 17.994 16.495 20.4932 12.3363 21.9427C12.1185 22.0165 11.882 22.013 11.6665 21.9327C7.49789 20.4932 3.99902 17.994 3.99902 12.9957V5.99793C3.99902 5.7328 4.10435 5.47853 4.29182 5.29105C4.4793 5.10358 4.73357 4.99825 4.9987 4.99825C6.99805 4.99825 9.49724 3.79864 11.2367 2.27914C11.4485 2.0982 11.7179 1.99878 11.9964 1.99878C12.275 1.99878 12.5444 2.0982 12.7562 2.27914C14.5056 3.80864 16.9948 4.99825 18.9941 4.99825C19.2593 4.99825 19.5136 5.10358 19.701 5.29105C19.8885 5.47853 19.9938 5.7328 19.9938 5.99793V12.9957Z" stroke="#E46C25" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <strong>{t('about.info.type')}</strong>
                </div>
                <p>{t('about.info.type_val')}</p>
              </div>
              <div className="info-card">
                <div className="info-icon-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline><polyline points="16 7 22 7 22 13"></polyline></svg>
                  <strong>{t('about.info.est')}</strong>
                </div>
                <p>{t('about.info.est_val')}</p>
              </div>
              <div className="info-card">
                <div className="info-icon-title">
                  <svg width="23.992" height="23.992" viewBox="0 0 24 24" fill="none" style={{flexShrink: 0}}>
                    <path d="M21.7942 9.99666C22.2507 12.2372 21.9254 14.5666 20.8723 16.5963C19.8193 18.626 18.1023 20.2334 16.0076 21.1503C13.9129 22.0673 11.5671 22.2385 9.36152 21.6352C7.15591 21.032 5.22376 19.6909 3.88727 17.8355C2.55079 15.9802 1.89077 13.7227 2.01727 11.4396C2.14377 9.15646 3.04915 6.98573 4.58242 5.28936C6.1157 3.59299 8.18418 2.47353 10.4429 2.11767C12.7017 1.76181 15.0142 2.19105 16.9947 3.33382" stroke="#4BA83D" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8.99707 10.9965L11.9961 13.9955L21.9928 3.99878" stroke="#4BA83D" strokeWidth="1.99935" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <strong>{t('about.info.cert')}</strong>
                </div>
                <p>{t('about.info.cert_val')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;


